<template lang="pug">
.study-header
  .study-header__content(v-if='isOpened')
    .study-header__content__info
      .study-header__content__info__unit
        .study-header__content__info__unit__title.font-bold
          slot(name='userUidTitle')
        .study-header__content__info__unit__value {{ userUid }}
      .study-header__content__info__unit
        .study-header__content__info__unit__title.font-bold
          slot(name='userNameTitle')
        .study-header__content__info__unit__value {{ userName }}

    button-return.study-header__content__button(@click='returnEvent', v-if='isFirstTime')
      slot(name='returnText')

  .study-header__toggle(:data-opened='isOpened')
    fa-icon.study-header__toggle__icon(:icon='toggleIcon', @click='changeToggle')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonReturn from '@/components/molecules/student/ButtonReturn.vue'

/**
 * 学習画面ヘッダー
 */
@Component({
  components: {
    ButtonReturn,
  },
})
export default class StudyHeader extends Vue {
  // 戻るボタン押下時イベント
  @Prop()
  returnEvent!: Function

  // 初回フラグ
  @Prop({ default: false })
  isFirstTime!: Boolean

  // 開閉フラグ
  private isOpened = false

  // ユーザUID
  private get userUid() {
    return this.$bcbtCookies.authBcbt.get()?.uid || ''
  }
  // ユーザ名
  private get userName() {
    return this.$bcbtCookies.authBcbt.get()?.currentApiUserName || ''
  }

  private get toggleIcon() {
    return this.isOpened ? 'angle-up' : 'angle-down'
  }

  private changeToggle() {
    this.isOpened = !this.isOpened
    this.$emit('change-toggle', this.isOpened)
  }
}
</script>

<style lang="stylus" scoped>
.study-header
  padding 15px 0
  border-bottom 2px solid var(--color-study-header__border)
  &__content
    display flex
    align-items center
    justify-content space-between
    &__info
      display flex
      flex-wrap wrap
      &__unit
        display flex
        align-items center
        margin 5px 20px 5px 0
        &__title
          background-color var(--color-study-header-title__background)
          padding 5px 10px
          border-radius 20px
          margin-right 10px
    &__button
      width 160px
  &__toggle
    position absolute
    top 0
    left calc(50% - 20px)
    text-align center
    &__icon
      cursor pointer
      width 40px
      height 32px
      color var(--color-study-header__icon)
    &[data-opened='true']
      top 44px
</style>
